module.exports = __webpack_public_path__ + "static/media/11.0e1f55a6.png";